module.exports = __webpack_public_path__ + "img/cab_430.432b54fc.jpg";